import React from 'react';
import {Link} from 'react-router-dom';

import FolderLayout from 'Components/HumanResources/StaffFolder/FolderLayout';
import {Card, SimpleTable} from 'Components/HumanResources/StaffFolder/Ui';
import {Loading} from 'Components/Partials';

import UserRatesApi from 'Services/Api/Admin/HumanResources/UserRates';

/**
 * Staff folder: Rates. The person's current hourly rates.
 * Rates are stored without start or end dates, so there is no rate history to show yet.
 */
export default class Rates extends React.Component {
    /**
     * @var state
     */
    state = {
        rates: null,
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        const response = await UserRatesApi.get({user: this.props.match.params.user});

        this.setState({rates: response.success ? response.data.data : []});
    };

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const userId = this.props.match.params.user;
        const {rates} = this.state;
        const current = (rates ?? []).filter(rate => rate.value !== null && rate.value !== '');
        const unset = (rates ?? []).filter(rate => rate.value === null || rate.value === '');

        return (
            <FolderLayout userId={userId}>
                {() => rates === null ? <Loading/> : (
                    <div className="space-y-5">
                        <div className="flex flex-wrap items-center justify-between gap-4">
                            <h2 className="font-league-spartan font-bold text-2xl">Current rates</h2>
                            <Link
                                to={`/admin/human-resources/user-rates/${userId}`}
                                className="bg-app-supporting-yellow text-white font-bold rounded-full px-4 py-2"
                            >
                                Change rates
                            </Link>
                        </div>

                        {current.length === 0 && (
                            <Card><p>No rates set for this person yet.</p></Card>
                        )}

                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                            {current.map(rate => (
                                <div key={rate.id} className="bg-white border border-gray-200 rounded-2xl p-4">
                                    <div className="text-sm text-gray-600">{rate.name}</div>
                                    <div className="font-league-spartan font-bold text-3xl">£{Number(rate.value).toFixed(2)}</div>
                                    <div className="text-sm text-gray-600">an hour</div>
                                </div>
                            ))}
                        </div>

                        <div className="rounded-2xl bg-yellow-50 border border-yellow-200 p-4">
                            <span className="font-bold">A rate change only applies to timesheet entries made after it.</span>
                            {' '}Entries already on the timesheet keep the rate they were saved with, so change those by hand if they need it.
                        </div>

                        {unset.length > 0 && (
                            <Card title="Rates not used for this person" id="r-unset">
                                <SimpleTable headings={['Rate']} rows={unset.map(rate => [rate.name])} />
                            </Card>
                        )}
                    </div>
                )}
            </FolderLayout>
        );
    }
}
